export default function Paragraph({ text }) {
  return <p>{text}</p>;
}
